import { RIVALS_LIST_SPORTS } from "rivals/shared/constants";
import { CareerType } from "../Career";

export type BasePersonList = {
  careerType?: CareerType;
  change?: number;
  firstName?: string;
  lastName?: string;
  name?: string;
  ordinality?: number;
  personId: number;
  personListId?: number;
};

export interface BaseCollegePlayer {
  athleteUrl: string;
  athleticYear: string;
  collegePlayerId: number;
  collegePlayerProfileImage?: string;
  entryType: string;
  exitCollegeColor?: string;
  exitCollegeLogo?: string;
  exitCollegeName?: string;
  exitType?: string;
  firstName: string;
  fullName: string;
  lastName: string;
  originCollegeColor?: string;
  originCollegeLogo?: string;
  originCollegeName: string;
  transferPosition: string;
  transferRating: number;
  transferStars: number;
  transferYear: number;
}

export type CollegePlayer = BasePersonList & {
  collegePlayer: BaseCollegePlayer;
};

export type Prospect = BasePersonList & {
  prospect: {
    fullName: string;
    prospectId: number;
    prospectRating: number;
    prospectStars: number;
    recruitYear: number;
  };
};

export type PersonList = CollegePlayer | Prospect;

export enum PersonTypes {
  COLLEGE_PLAYER = "CollegePlayer"
}

export interface ListPeople {
  count: number;
  people: PersonList[];
}

export const mapListKindToCareerType = (listKind: ListKinds): CareerType => {
  switch (listKind) {
    case ListKinds.TRANSFER_PORTAL:
      return CareerType.COLLEGE_PLAYER;

    default:
      return CareerType.PROSPECT;
  }
};

export enum ListKinds {
  JUCO = "juco",
  OTHER = "other",
  POSITION = "position",
  PREP = "prep",
  RIVALS_100 = "rivals100",
  RIVALS_150 = "rivals150",
  RIVLAS_250 = "rivals250",
  STATE = "state",
  TRANSFER_PORTAL = "transferportal"
}

export enum ListTypes {
  DEPTH_CHART = "DepthChart",
  RANK = "Rank",
  ROSTER = "Roster"
}

export enum PublicationStatuses {
  DRAFT = "DRAFT",
  PUBLISHED = "PUBLISHED"
}

export interface PeopleData {
  error?: string;
  people: PersonList[];
  searching: boolean;
  total: number;
}

export interface ListData {
  history: List[];
  list: List;
}

export interface List {
  childId: number | null;
  createdAt: string;
  current: boolean | null;
  kind: ListKinds;
  lastModifiedDate: string;
  lastModifyingAuthorId: number | null;
  lastModifyingAuthorName: string | null;
  lastVersionId: number;
  listId: number;
  listType: ListTypes;
  liveAt: string | null;
  name: string;
  originalAuthorId: number | null;
  originalAuthorName: string | null;
  positionAbbreviation?: string;
  published: boolean;
  siteId: number;
  siteName: string;
  sport: RIVALS_LIST_SPORTS.FOOTBALL | RIVALS_LIST_SPORTS.BASKETBALL;
  stateName?: string;
  version: number;
  year: number;
}

export interface SaveListConfig {
  createNewVersion?: boolean;
  draft?: boolean;
}

export enum AdminListQueryParameterTypes {
  TRANSFER_PORTAL_RANK = "transfer_portal_ranks"
}

export interface AdminListBasePathParameters {
  id: string;
  type: AdminListQueryParameterTypes;
}
